import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 add_products_to_dispatch_and_complete_dispatch: { message: "idle" },
};

export const add_products_to_dispatch_and_complete_dispatch_Slice = createSlice({
 name: "add_products_to_dispatch_and_complete_dispatch",
 initialState,
 reducers: {
  success_add_products_to_dispatch_and_complete_dispatch: (state, action) => {
   state.add_products_to_dispatch_and_complete_dispatch = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_add_products_to_dispatch_and_complete_dispatch: (state, action) => {
   state.add_products_to_dispatch_and_complete_dispatch = { status: app_consts.FAIL, message: action.payload };
  },
  reset_add_products_to_dispatch_and_complete_dispatch: (state) => {
   state.add_products_to_dispatch_and_complete_dispatch = { status: app_consts.IDLE };
  },
  loading_add_products_to_dispatch_and_complete_dispatch: (state) => {
   state.add_products_to_dispatch_and_complete_dispatch = { status: app_consts.LOADING };
  },
 }
});

export const { success_add_products_to_dispatch_and_complete_dispatch, fail_add_products_to_dispatch_and_complete_dispatch, reset_add_products_to_dispatch_and_complete_dispatch, loading_add_products_to_dispatch_and_complete_dispatch } = add_products_to_dispatch_and_complete_dispatch_Slice.actions;

export default add_products_to_dispatch_and_complete_dispatch_Slice.reducer;